export interface UploadedFile {
    id: string;
    name: string;
}

export interface UploadProgressPayload {
    id: string;
    name: string;
    percent: number;
}

export interface StoreUploadState {
    uploadedFiles: UploadedFile[];
    uploadProgress: Record<string, number>;
    loading: boolean;
    hasError: boolean;
    project?: any;
}

const initialState: StoreUploadState = {
    uploadedFiles: [],
    uploadProgress: {},
    loading: false,
    hasError: false,
    project: undefined,
};

// Action Types
const SET_STORE_UPLOAD_PROJECT = "SET_STORE_UPLOAD_PROJECT";
const SET_STORE_UPLOAD_PROGRESS = "SET_STORE_UPLOAD_PROGRESS";
const SET_STORE_LOADING = "SET_STORE_LOADING";
const SET_STORE_ERROR = "SET_STORE_ERROR";
const CLEAR_STORE_UPLOADS = "CLEAR_STORE_UPLOADS";
const REMOVE_STORE_FILE = "REMOVE_STORE_FILE";

// Reducer
export default function storeUploadReducer(
    state: StoreUploadState = initialState,
    action: any
): StoreUploadState {
    switch (action.type) {
        case SET_STORE_UPLOAD_PROJECT:
            return { ...state, project: action.payload };

        case SET_STORE_UPLOAD_PROGRESS: {
            const { id, name, percent } = action.payload;
            const exists = state.uploadedFiles.some((f) => f.id === id);

            return {
                ...state,
                uploadedFiles: exists ? state.uploadedFiles : [...state.uploadedFiles, { id, name }],
                uploadProgress: { ...state.uploadProgress, [id]: percent },
            };
        }

        case SET_STORE_LOADING:
            return { ...state, loading: action.payload };

        case SET_STORE_ERROR:
            return { ...state, hasError: action.payload };

        case CLEAR_STORE_UPLOADS:
            return { ...initialState };

        case REMOVE_STORE_FILE: {
            const { [action.payload]: _, ...restProgress } = state.uploadProgress;
            return {
                ...state,
                uploadedFiles: state.uploadedFiles.filter((f) => f.id !== action.payload),
                uploadProgress: restProgress,
            };
        }

        default:
            return state;
    }
}

// Action Creators
export const setStoreUploadProject = (project: any) => ({
    type: SET_STORE_UPLOAD_PROJECT,
    payload: project,
});

export const setStoreUploadProgress = (payload: UploadProgressPayload) => ({
    type: SET_STORE_UPLOAD_PROGRESS,
    payload,
});

export const setStoreLoading = (loading: boolean) => ({
    type: SET_STORE_LOADING,
    payload: loading,
});

export const setStoreError = (hasError: boolean) => ({
    type: SET_STORE_ERROR,
    payload: hasError,
});

export const clearStoreUploads = () => ({
    type: CLEAR_STORE_UPLOADS,
});

export const removeStoreFile = (fileId: string) => ({
    type: REMOVE_STORE_FILE,
    payload: fileId,
});
